import { Conversation } from "@/lib/messaging";
import { useState } from "react";
import { ConversationList } from "./ConversationList";
import { ConversationView } from "./ConversationView";

export function MessagingSection() {
	const [selectedConversation, setSelectedConversation] =
		useState<Conversation | null>(null);

	return (
		<div className="space-y-6">
			<div>
				<h1 className="text-2xl font-semibold tracking-tight">
					Messages
				</h1>
			</div>

			<div className="grid grid-cols-1 lg:grid-cols-3 gap-6 h-[calc(100vh-220px)]">
				<div className="lg:col-span-1 overflow-y-auto border rounded-lg p-4 bg-white">
					<ConversationList
						onSelectConversation={setSelectedConversation}
						selectedConversationId={selectedConversation?.id}
					/>
				</div>
				<div className="lg:col-span-2 h-full">
					<ConversationView conversation={selectedConversation} />
				</div>
			</div>
		</div>
	);
}
